import './App.css';
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import HomeComponent from './components/home.component';
import ModelsComponent from './components/models.component';
import Profile from './components/profile.component';
import PolicyComponent from './components/policy.component';
import AboutComponent from './components/about.component';
import OrderComponent from './components/order.component';
import PaymentComponent from './components/payment.component';
import WorkerSheet from './components/worker.sheet';
import UserService from './service/user.service';
import { AppProvider, useAppContext } from './context/AppContext';

const tg = window.Telegram.WebApp;

function AppContent() {
    const { setIsWorker: setContextIsWorker } = useAppContext();
    const [user, setUser] = useState({});
    const [isWorker, setIsWorker] = useState(false);
    const [orderData, setOrderData] = useState({});
    const [admins, setAdmins] = useState([]);
    const [show, setShow] = useState(false);
    const [country, setCountry] = useState('ru');
    const [workerSheetOpen, setWorkerSheetOpen] = useState(false);

    useEffect(() => {
        tg.ready();
        tg.expand();
        const userId = tg.initDataUnsafe?.user?.id || 0;
        setUser({ id: userId });

        UserService.isWorker(userId).then(response => {
            setShow(true);
            setIsWorker(response.data);
            setContextIsWorker(response.data);
            UserService.getAdmins().then(res => setAdmins(res.data));
        }).catch(err => console.log(err.message));

        UserService.getRegion(userId).then(res => setCountry(res.data));
    }, []);

    return (
        <>
            {show && (
                <Router>
                    <Switch>
                        <Route exact path="/" render={() => (
                            <HomeComponent
                                showAdmin={isWorker}
                                onOpenWorkerSheet={() => setWorkerSheetOpen(true)}
                            />
                        )} />
                        <Route exact path="/models" render={() => (
                            <ModelsComponent user={user} region={country} />
                        )} />
                        <Route exact path="/profile/:id" render={() => (
                            <Profile user={user} admins={admins} region={country} />
                        )} />
                        <Route exact path="/policy" component={PolicyComponent} />
                        <Route exact path="/about" component={AboutComponent} />
                        <Route exact path="/order/:id" render={() => (
                            <OrderComponent setOrderData={setOrderData} user={user} />
                        )} />
                        <Route exact path="/payment" render={() => (
                            <PaymentComponent orderData={orderData} user={user} region={country} />
                        )} />
                    </Switch>
                </Router>
            )}
            {isWorker && (
                <WorkerSheet
                    user={user}
                    isOpen={workerSheetOpen}
                    onClose={() => setWorkerSheetOpen(false)}
                />
            )}
        </>
    );
}

function App() {
    return (
        <AppProvider>
            <AppContent />
        </AppProvider>
    );
}

export default App;
